import React from 'react';
import ReactDOM from 'react-dom';
import { CSSTransition } from 'react-transition-group';
import ScrollLock from '../utils/ScrollLock';
import rimg from 'rimg-shopify';
import SVG from './SVG.jsx';

rimg.init();

export default class Drawer extends React.PureComponent {
  constructor(props) {
    super();
    this.contentRef = React.createRef();
    this.lockedToEl = this.contentRef.current;
  }

  componentDidUpdate(prevProps) {
    if (this.props.open) {
      if (this.contentRef.current.querySelector('.ff-form')) {
        ScrollLock.lock(this.contentRef.current.querySelector('.ff-form'))
        this.lockedToEl = this.contentRef.current.querySelector('.ff-form');
      } else {
        ScrollLock.lock(this.contentRef.current)
        this.lockedToEl = this.contentRef.current;
      }
    } else if (prevProps.open) {
      if (this.lockedToEl && this.lockedToEl.closest('body')) {
        ScrollLock.unlock(this.lockedToEl)
      } else {
        ScrollLock.unlockAll();
      }
    }
  }

  componentWillUnmount() {
    if (this.lockedToEl && this.lockedToEl.closest('body')) {
      ScrollLock.unlock(this.lockedToEl)
    } else {
      ScrollLock.unlockAll();
    }
  }

  scrollToTop() {
    if (this.contentRef.current) {
      this.contentRef.current.scrollTop = 0;
    }
  }

  render() {
    let content;

    if (this.props.content) {
      content = (
        typeof this.props.content === 'string'
          ? <div className="rte text-content" dangerouslySetInnerHTML={{ __html: this.props.content }} />
          : this.props.content
      );
    }

    return ReactDOM.createPortal(
      <CSSTransition in={this.props.open}
        addEndListener={(node, done) => {
          node.addEventListener("transitionend", done, false);
          if (this.props.open) {
            rimg.watch(node)
            if (typeof this.props.onOpen === 'function') {
              this.props.onOpen();
            }
          }
        }}
        classNames="drawer"
        mountOnEnter={this.props.mountOnEnter}
        unmountOnExit={this.props.unmountOnExit}>
        <div className="react-drawer-wrap">
          <div className="drawer-overlay" onClick={(e) => { this.props._close() }}></div>
          <div className={`${this.props.className || ''} drawer`}>
            <button className="drawer-close" aria-label="Close" onClick={(e) => { e.preventDefault(); this.props._close() }}>
              <SVG icon="close" />
            </button>
            <div className={this.props.contentClass ? `drawer-content ${this.props.contentClass}` : 'drawer-content'} ref={this.contentRef}>
              {this.props.heading ? <div className="header-wrap"><h1 className="title">{this.props.heading}</h1></div> : null}
              {this.props.children}
              {content || null}
            </div>
          </div>
        </div>
      </CSSTransition>, document.body)
  }
}
